import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';
import type NestedSelectFilter from '@tajawal/web-flights-sdk/lib/stores/filter/base/nested-select-filter.store';
import type TimeFilterStore from '@tajawal/web-flights-sdk/lib/stores/filter/time-filter.store';

type FilterType = TimeFilterStore | NestedSelectFilter;

export function useStateOfNestedSelectFilter(store: FilterType) {
  return useMapStoreStateToClientState(store, (store: FilterType) => ({
    state: store.state,
    isDirty: store.isDirty,
    reset: store.reset,
    toggle: store.toggle,
    params: store.params,
  }));
}
